import ServiceType from '@/models/ServiceType'

export default class ServiceTypeRepo {
	static endpoint = '/api/service-type'

	static fetchAll () {
		return ServiceType.api().get(`${this.endpoint}`)
	}
}
